module.exports = __webpack_public_path__ + "img/circle.4d00cfb1.png";